import type { Service } from './useChannels'
import { useConnectChannel } from '~publish/hooks/useConnectChannel'
import { useCta } from '~publish/hooks/useCta'

import { ChannelSuggestionsIconRow } from './ChannelSuggestionsIconRow'

import type { JSX } from 'react'

const SUGGESTIONS_CTA = 'publish-sidebar-channels-addChannelSuggestions-1'
const MORE_CHANNELS_CTA = 'publish-sidebar-channels-moreChannels-1'

export const ChannelSuggestions = ({
  services,
}: {
  services: Service[]
}): JSX.Element => {
  const connectChannel = useConnectChannel({
    cta: SUGGESTIONS_CTA,
  })

  const { clicked: ctaClicked } = useCta(SUGGESTIONS_CTA, {
    upgradePathName: 'addChannel-upgrade',
  })

  const { clicked: moreChannelsCtaClicked } = useCta(MORE_CHANNELS_CTA, {
    upgradePathName: 'addChannel-upgrade',
  })

  const onChannelClick = (channelService: Service): void => {
    ctaClicked()
    connectChannel(channelService)
  }

  const handleMoreChannelsClick = (): void => {
    moreChannelsCtaClicked()
    const { actions } = window?.appshell || {}
    actions?.openChannelStorefront({
      cta: MORE_CHANNELS_CTA,
    })
  }

  return (
    <ChannelSuggestionsIconRow
      services={services}
      onChannelClick={onChannelClick}
      onMoreChannelsClick={handleMoreChannelsClick}
    />
  )
}
